import { render, staticRenderFns } from "./PlatformFooter.vue?vue&type=template&id=7bafb27d"
import script from "./PlatformFooter.vue?vue&type=script&lang=js"
export * from "./PlatformFooter.vue?vue&type=script&lang=js"
import style0 from "./PlatformFooter.vue?vue&type=style&index=0&id=7bafb27d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports